import { render, staticRenderFns } from "./RemoteDownload.vue?vue&type=template&id=63755952&scoped=true"
import script from "./RemoteDownload.vue?vue&type=script&lang=js"
export * from "./RemoteDownload.vue?vue&type=script&lang=js"
import style0 from "./RemoteDownload.vue?vue&type=style&index=0&id=63755952&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63755952",
  null
  
)

export default component.exports